import * as Yup from 'yup';

export interface InfantRoadToHealthModel {
  weightAtBirth?: number;
  lengthAtBirth?: number;
  height?: number;
  roadToHealthBook?: string;
  notRoadToHealthBook?: boolean;
  hasMaternalCaseRecord?: boolean;
}

export const initialInfantRoadToHealthValues: InfantRoadToHealthModel = {
  weightAtBirth: 0,
  lengthAtBirth: 0,
  roadToHealthBook: '',
  notRoadToHealthBook: false,
};

export const infantRoadToHealthModelSchema = Yup.object().shape({
  weightAtBirth: Yup.string()
    .required('Please enter a value between 500 and 7000g.')
    .test(
      'is-valid-weight',
      'Please enter a value between 500 and 7000g.',
      (val: any) => {
        if (!val) return false;

        const cleanValue = val.toString().replaceAll(',', '.');
        const num = parseFloat(cleanValue);

        return !isNaN(num) && num >= 500 && num <= 7000;
      }
    ),

  lengthAtBirth: Yup.string()
    .required('Please enter a value between 25 and 70cm.')
    .test(
      'is-valid-length',
      'Please enter a value between 25 and 70cm.',
      (val: any) => {
        if (!val) return false;

        const cleanValue = val.toString().replaceAll(',', '.');
        const num = parseFloat(cleanValue);

        return !isNaN(num) && num >= 25 && num <= 70;
      }
    ),

  roadToHealthBook: Yup.string(),
  notRoadToHealthBook: Yup.boolean(),
});
